module.exports = __webpack_public_path__ + "static/media/all-thread.002e7d83.svg";